import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZonelessChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { Amplify } from 'aws-amplify';
import { awsConfig } from '../../../../libs/includes/aws-export';
import { provideHttpClient } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AppErrorHandler } from './app.error-handler';
import { APP_ROUTES } from './app-routing';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { loadGTM } from '@resparke/utils/gtm';
import { environment } from '../environments/environment';


export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

Amplify.configure(awsConfig.clientApp);

const providers = [
  provideZonelessChangeDetection(),
  importProvidersFrom(MatMomentDateModule),
  { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
  { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
  provideHttpClient(),
  provideRouter(APP_ROUTES),
  { provide: ErrorHandler, useClass: AppErrorHandler },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true } },
  provideAppInitializer(() => {
    const initializerFn = ((iconRegistry: MatIconRegistry) => () => {
      const defaultFontSetClasses = iconRegistry.getDefaultFontSetClass();
      const outlinedFontSetClasses = defaultFontSetClasses
        .filter((fontSetClass) => fontSetClass !== 'material-icons')
        .concat(['material-symbols-outlined']);
      iconRegistry.setDefaultFontSetClass(...outlinedFontSetClasses);
    })(inject(MatIconRegistry));
    return initializerFn();
  }),
];

const enableGtm = environment.local ? !['localhost', environment.local.domain].includes(window.location.hostname) : true;
if (enableGtm) {
   providers.push(
    provideAppInitializer(() => loadGTM(environment.gtm)),
  );
}


export const appConfig: ApplicationConfig = {
  providers,
};
